import type { LDClient } from 'launchdarkly-js-client-sdk';

import { trackerInterface } from 'app-components/utils/core';

import mixpanel, { dynamicDefaultPropertiesCreator } from 'utils/core/mixpanel';
import { trackLaunchDarklyEvent } from './launchDarklyEvents';

declare global {
  interface Window {
    ldClient?: LDClient;
  }
}

trackerInterface.trackerInterfaceInit({
  track: (event, props) => {
    mixpanel.track(event, props);
    trackLaunchDarklyEvent(typeof window === 'undefined' ? undefined : window.ldClient, event, props);
  },
  identify: (userId) => mixpanel.identify(userId),
  getIdentity: () => mixpanel.get_distinct_id(),
  timeEvent: (event) => mixpanel.time_event(event),
  dynamicDefaultProperties: dynamicDefaultPropertiesCreator,
  updateProfile: (props) => mixpanel.people.set(props),
});
